import React from 'react';
import { ItemCard } from '../ui/ItemCard';
import { CardsLayout } from '../ui/CardsLayout';
import { NewSection } from '../NewSection';
import { SearchItemsQuery } from '../../graphql/graphql';

type SearchResultNode =
  SearchItemsQuery['itemsConnection']['edges'][number]['node'];

interface Props {
  items: SearchResultNode[];
}

export const SearchItemsPaginationSection: React.FC<Props> = ({ items }) => {
  return (
    <NewSection id="search-page-regular-items">
      <CardsLayout>
        {items.map(item => (
          <ItemCard key={item.id} {...item} inBookmarks={false} />
        ))}
      </CardsLayout>
    </NewSection>
  );
};
